module.exports = __webpack_public_path__ + "img/Vuetify.280aaeaa.png";